import * as Icons from "lucide-react";
import { RepairWhatsAppButton } from "@/components/whatsapp/WhatsAppButton";
import { motion } from "framer-motion";

export const ServiceCard = ({ service }) => {
  const Icon = Icons[service.icon] || Icons.Wrench;
  return (
    <motion.div
      variants={{ hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0, transition: { duration: 0.55 } } }}
      className="group flex flex-col rounded-2xl border border-border bg-card p-6 transition-colors hover:border-[hsl(var(--ink))]"
      data-testid={`service-card-${service.id}`}
    >
      <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[hsl(var(--paper))] text-[hsl(var(--ink))] transition-colors group-hover:bg-[hsl(var(--accent))] group-hover:text-white">
        <Icon className="h-5 w-5" aria-hidden="true" />
      </span>
      <h3 className="mt-4 text-base font-semibold">{service.name}</h3>
      <p className="mt-1.5 flex-1 text-sm text-[hsl(var(--ink-soft))]">{service.desc}</p>
      <RepairWhatsAppButton
        serviceName={service.name}
        label="Enquire"
        className="btn-outline mt-4 w-full text-xs"
        testId={`service-whatsapp-${service.id}`}
      />
    </motion.div>
  );
};
